/**
 * PII scrubber — strips tokens, passwords, and similar secrets from log payloads
 * before they leave the browser. Defense in depth: the server also truncates
 * oversized strings, but the client is the last place we can redact before
 * transport.
 */

const JWT_REGEX = /eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g;
const KV_SECRET_REGEX =
  /(password|pwd|pass|senha|token|secret|apiKey|authorization)([\s"']?\s*[:=]\s*["']?)[^\s,"'}]+/gi;
const SENSITIVE_KEY =
  /^(password|pwd|pass|senha|token|secret|apikey|authorization|auth)$/i;
const MAX_STRING = 10000;

function scrubString(input) {
  if (typeof input !== "string" || input.length === 0) return input;
  let out = input.replace(JWT_REGEX, "[JWT_REDACTED]");
  out = out.replace(KV_SECRET_REGEX, (_, key, sep) => `${key}${sep}[REDACTED]`);
  if (out.length > MAX_STRING) {
    out = out.slice(0, MAX_STRING) + "... [TRUNCATED]";
  }
  return out;
}

function scrubValue(value, depth = 0) {
  if (depth > 6) return "[MAX_DEPTH]";
  if (value == null) return value;

  if (typeof value === "string") return scrubString(value);
  if (typeof value === "number" || typeof value === "boolean") return value;

  if (Array.isArray(value)) {
    return value.map((v) => scrubValue(v, depth + 1));
  }

  if (typeof value === "object") {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      if (SENSITIVE_KEY.test(k)) {
        out[k] = "[REDACTED]";
      } else {
        out[k] = scrubValue(v, depth + 1);
      }
    }
    return out;
  }

  // Functions, symbols — not loggable.
  return undefined;
}

export function scrubString_(s) {
  return scrubString(s);
}

export function scrub(value) {
  return scrubValue(value, 0);
}

export default scrub;
